import React, { useCallback, useEffect } from "react";
import cx from "classnames";
import type { ModalProps } from "reactstrap";
import { Modal } from "reactstrap";
import { XCircleLoader } from "./XCircleLoader/XCircleLoader";
import { useSetIsModalOpen } from "stores/loadingStateStore";

type Props = Omit<ModalProps, "isOpen"> & {
  isOpen: boolean;
  isLoading: boolean;
  children?: React.ReactNode;
};

export const ModalWrapper = ({
  isOpen,
  onClosed,
  toggle,
  size,
  isLoading = true,
  children,
  ...rest
}: Props) => {
  const setIsModalOpen = useSetIsModalOpen();

  useEffect(() => {
    setIsModalOpen(true);
    return () => setIsModalOpen(false);
  }, [setIsModalOpen]);

  const handleClose = useCallback(() => {
    onClosed?.();
  }, [onClosed]);

  return (
    <Modal
      isOpen={isOpen}
      onClosed={handleClose}
      toggle={toggle}
      size={size}
      contentClassName={cx({ "border-0": isLoading })}
      scrollable={false}
      {...rest}
    >
      {isLoading && (
        <XCircleLoader classNames="position-absolute top-0 left-0 w-100 h-100 z-1" />
      )}
      <div className={cx("bg-white", { "d-none": isLoading })}>{children}</div>
    </Modal>
  );
};
